// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import {
    canAddToCart as canAddToCartSelector,
    hasEnoughInventory as hasEnoughInventorySelector,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import updateSubscription from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateSubscription";
import { ProductSubscriptionDto } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import ProductDeliveryScheduleButton from "@insite/content-library/Components/ProductDeliveryScheduleButton"; // Valtech Custom Code
import { ButtonPresentationProps } from "@insite/mobius/Button";
import * as React from "react";
import { useDispatch } from "react-redux";
import { css } from "styled-components";

/* Valtech Custom Code */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import ProductDeliveryScheduleButton from "@store/Overrides/Components/ProductDeliveryScheduleButton";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Valtech Custom Code */

type Props = WidgetProps & HasProductContext;

export interface ProductDetailsDeliveryScheduleButtonStyles {
    button?: LinkPresentationProps; // Valtech Custom Code
    // Valtech Custom Code
    wrapper?: InjectableCss;
}

export const deliveryScheduleButtonStyles: ProductDetailsDeliveryScheduleButtonStyles = {
    wrapper: {
        css: css`
            display: flex;
            ${x => spacingStyles(pxToRem(8), x.theme.design.product.detail.contentSpacing)}
        `,
    },
};

const styles = deliveryScheduleButtonStyles;

const ProductDetailsDeliveryScheduleButton = (props: Props) => {
    const {
        productContext: { product, productInfo },
    } = props;

    const canAddToCart = useAppSelector(state =>
        canAddToCartSelector(
            state,
            product,
            productInfo,
            state.pages.productDetails.configurationCompleted,
            state.pages.productDetails.variantSelectionCompleted,
        ),
    );
    const hasEnoughInventory = useAppSelector(state => hasEnoughInventorySelector(state, props.productContext));
    const subscription = useAppSelector(state => state.pages.productDetails.subscription);
    const dispatch = useDispatch();

    if (!product.detail?.isSubscription || !product.detail?.subscription || !hasEnoughInventory || !canAddToCart) {
        return null;
    }

    const saveScheduleHandler = (updatedSubscription: ProductSubscriptionDto) => {
        dispatch(updateSubscription({ subscription: updatedSubscription }));
    };

    return (
        <StyledWrapper {...styles.wrapper} /* Valtech Custom Code */>
            <ProductDeliveryScheduleButton
                subscription={subscription || product.detail.subscription}
                disabled={productInfo.qtyOrdered <= 0}
                onSave={saveScheduleHandler}
                extendedStyles={styles.button}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(ProductDetailsDeliveryScheduleButton),
    definition: {
        displayName: "Delivery Schedule Button",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
